<template>
    <div id="bene-bank-transfer-container">
        <f7-list form class="form-group" v-if="showFormSet.bankTransfer">
            <f7-list-input
                input-id     ="bankBranch"
                id           ="bankBranchInput"
                name         ="bankBranch"
                class        ="clickable-row use-chevron"

                v-if         ="showFormInput.bankTransfer.bankBranch"
                :label       ="$t('beneficiary-bank-branch')"
                :placeholder ="$t('beneficiary-select-bank-branch')"
                :value       ="bankBranch"
                @change      ="changeBankBranch($event.target.value);"
                v-show       ="!isAutocomplete"
                autocomplete ="off"
                outline
                floating-label
            >
                <f7-link popover-open=".popover-dropdown-bank-branch" slot="content-start" class="clickable-item"></f7-link>
            </f7-list-input>

            <f7-popover id="dropdownBankBranch" class="popover-dropdown-bank-branch dropdown-default dropdown beneficiary" :backdrop="true">
                <f7-list>
                    <f7-list-item popover-close link="#"
                    v-for="(bb, key) in bankBranchList"
                    :key="key"
                    selected=""
                    @click="changeBankBranch(key); validateInput($event.target); setInput('bankBranch');">
                    {{bb}}
                    </f7-list-item>
                </f7-list>
            </f7-popover>

            <f7-list-input
                input-id     ="bankBranchAutocomplete"
                name         ="bankBranch"
                type         ="text"

                :label       ="$t('beneficiary-bank-branch')"
                :placeholder ="$t('beneficiary-select-bank-branch')"
                :value       ="bankBranch"
                v-show       ="isAutocomplete"
                autocomplete="off"
                outline
                floating-label
                clear-button
            ></f7-list-input>
        </f7-list>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    export default {
        props: {
        },
        mounted() {
            this.init()
        },
        data: function() {
            return {
                isAutocomplete : false
            }
        },
        computed: {
            ...mapGetters('beneficiary', [
                'showFormSet',
                'showFormInput',
                'bankBranch',
                'bankBranchId',
                'bankBranchList',
                'showPreloaderState',
                'forceRerenderKey',
                'isCreateBeneficiary',
            ])
        },
        components: {
        },
        methods: {
            ...mapActions('beneficiary', [
                'setBankBranch',
                'setShowPreloaderState'
            ]),

            async init(){
                const self    = this;
                const popover = ".beneficiary.popover-dropdown-bank-branch";
                const popoverInner = ".beneficiary.popover-dropdown-bank-branch .popover-inner";
                const popoverId = "dropdownBankBranch";
                const inputId = "bankBranch";
                const inputListId = "#bankBranchInput";
                await self.setDropdownDirection(popover, popoverInner, popoverId, inputId, inputListId)

                //console.log("BANK LIST LENGTH : "+ Object.keys(self.bankBranchList).length)
                //console.log("BANK BRANCH LIST : ", self.bankBranchList)

                const app          = self.$f7;
                self.autocompleteBankBranch = app.autocomplete.create({
                    inputEl: '#bankBranchAutocomplete',
                    openIn : 'dropdown',
                    class  : '',
                    closeOnSelect: true,
                    source : function(query, render) {
                        let results = [];
                        if(query.length === 0) {
                            //render(results);
                            self.autocompleteBankBranch.close();
                            return;
                        }else{
                            self.autocompleteBankBranch.open();
                        }

                        // Find Matched Items
                        Object.keys(self.bankBranchList).forEach(key => {
                            if(self.bankBranchList[key].toLowerCase().indexOf(query.toLowerCase()) >= 0) {
                                results.push(self.bankBranchList[key]);
                            }
                        })

                        // Render Items By Passing Array With Result Items
                        render(results.sort());
                    },
                    on     : {
                        change : function(val){
                            //console.log("SELECTED : "+val)

                            let selectedBankBranchId = 0;
                            let entries = Object.entries(self.bankBranchList)
                            entries.map( ([bankBranchId, bankBranchName]) => {
                                if(bankBranchName.toString().toLowerCase() == val.toString().toLowerCase()){
                                    selectedBankBranchId = bankBranchId;
                                }
                            });

                            self.changeBankBranch(selectedBankBranchId)
                            self.validateInput(document.getElementById("bankBranchAutocomplete"))
                        }
                    }
                })

                if(Object.keys(self.bankBranchList).length > 10){ // USE AUTOCOMPLETE
                    self.isAutocomplete = true;
                }else{ // USE DROPDOWN
                    self.isAutocomplete = false;
                }
            },

            changeBankBranch(id){
                this.$emit("changeBankBranch", id);
            },

            validateInput(inputEl){
                this.$emit("validateInput", inputEl);
            },

            setInput(inputEl){
                this.$emit("setInput", inputEl);
            }
        }
    }
</script>